import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
} from "chart.js";
import "./Overview.css";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import MedicationIcon from "@mui/icons-material/Medication";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import { useEffect, useState } from "react";
import { db } from "../../../../firebaseConfig";
import { onValue, ref } from "firebase/database";
import LinearGraph from "../../components/overview/LinearGraph";
import Report from "../../components/overview/Report";
import Traffic from "../../components/overview/Traffic";
import AddTherapist from "./AddTherapist";
import { Fade, Zoom } from "react-reveal";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend
);

export default function Overview() {
  const [usersNo, setUsersNo] = useState(0);
  const [therapistsNo, setTherapistsNo] = useState(0);
  const [isAddTherapist, setIsAddTherapist] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    // Subscribe to real-time updates
    const starCountRef = ref(db, "users");
    const unsubscribe = onValue(starCountRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        setUsersNo(Object.values(data).length);
      }
    });
    // Cleanup the subscription on component unmount
    return () => {
      unsubscribe();
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    // Subscribe to real-time updates
    const starCountRef = ref(db, "therapists");
    const unsubscribe = onValue(starCountRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        setTherapistsNo(Object.values(data).length);
      }
    });
    // Cleanup the subscription on component unmount
    return () => {
      unsubscribe();
    };
  }, []);

  const summaryCard = (Icon, num, title) => (
    <div className="summary-card">
      <div className="icon-div">
        <Icon className="icon" />
      </div>
      <div className="details">
        <h2>{num}</h2>
        <p>Total {title}</p>
      </div>
    </div>
  );

  return (
    <div className="overview">
      <div className="overview-container">
        <div className="overview-header">
          <h2>Overview.</h2>
          <div
            className="add-therapists-btn"
            onClick={() => setIsAddTherapist(true)}
          >
            + Add Therapist
          </div>
        </div>
        <Fade down>
          <div className="summaries">
            {summaryCard(PersonOutlineIcon, usersNo, "users")}
            {summaryCard(MedicationIcon, therapistsNo, "therapists")}
            {summaryCard(AttachMoneyIcon, 29000, "revenue")}
          </div>
        </Fade>

        <div className="graphs">
          <LinearGraph />
          <div className="reports">
            <Report />
            <Traffic />
          </div>
        </div>
      </div>
      {isAddTherapist && <AddTherapist setIsAddTherapist={setIsAddTherapist} />}
    </div>
  );
}
